export enum InstructorStatusType {
    APPROVED = 'approved',
    REJECTED = 'rejected',
    BLOCKED = 'blocked',
    NOT_YET_APPROVED = 'not_yet_approved',
    RETURNED = 'returned'
  }